import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-time-picker",
  templateUrl: "./time-picker.component.html",
  styleUrls: ["./time-picker.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimePickerComponent),
      multi: true,
    },
  ],
})
export class TimePickerComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder: string = "Select time";
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;

  value: string = "";
  hours: number[] = [];
  minutes: number[] = [];
  selectedHour: number = 0;
  selectedMinute: number = 0;
  isOpen: boolean = false;

  private onChange = (value: string) => {};
  private onTouched = () => {};

  constructor() {
    for (let i = 0; i < 24; i++) {
      this.hours.push(i);
    }

    for (let i = 0; i < 60; i++) {
      this.minutes.push(i);
    }
  }

  ngOnInit(): void {
    this.selectedHour = 0;
    this.selectedMinute = 0;
  }

  toggleDropdown(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectHour(hour: number): void {
    this.selectedHour = hour;
    this.updateValue();
  }

  selectMinute(minute: number): void {
    this.selectedMinute = minute;
    this.updateValue();
    setTimeout(() => {
      this.isOpen = false;
    }, 100);
  }

  private updateValue(): void {
    const timeString = `${this.selectedHour
      .toString()
      .padStart(2, "0")}:${this.selectedMinute.toString().padStart(2, "0")}`;
    this.value = timeString;
    this.onChange(timeString);
    this.onTouched();
  }

  formatTime(hour: number, minute: number): string {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  writeValue(value: string): void {
    if (value) {
      this.value = value;
      const [hour, minute] = value.split(":").map(Number);
      this.selectedHour = hour || 0;
      this.selectedMinute = minute || 0;
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
    this.updateValue();
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onBlur(): void {
    setTimeout(() => {
      this.isOpen = false;
      this.onTouched();
    }, 150);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.isOpen = false;
    }
  }
}
